<script setup lang="ts">
import { useClosedOrResolvedCardCustomisation } from './composables/useConversationsCustomisation';
import { useRecentResolvedTicketIdQuery } from './composables/useRecentResolvedTicketIdQuery';
import ConversationsList from './components/ConversationsList.vue';
import { useClosedOrResolvedConversations } from '@/common/api/conversations.api';
import { useBotUser } from '@/stores/useBotUser';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const cardCustomisation = useClosedOrResolvedCardCustomisation();

const { user, guestUser } = storeToRefs(useBotUser());
const requesterId = computed(() => user.value.id || guestUser.value?.id || '');

const { recentResolvedTicketId } = useRecentResolvedTicketIdQuery(requesterId);
</script>

<template>
  <ConversationsList
    title="Closed/Resolved Conversations"
    :requester-id="requesterId"
    :query-hook="useClosedOrResolvedConversations"
    :customisation="cardCustomisation"
    page-query-key="closedPage"
    :recent-resolved-ticket-id="recentResolvedTicketId"
  />
</template>
